module.exports = __webpack_public_path__ + "images/onboarding-banner/one-more-step.c30033bd52a98dec6776.png";